import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Col, Row, Card, CardBody } from "react-bootstrap";
import "../utils/index.css";
import ReactCountryFlag from "react-country-flag";
const SimulerChangementCountryModal = ({ show, onClose, commission, onApply,commissions }) => {
  const [montant, setMontant] = useState(0);
  const [nouveauPayIn, setNouveauPayIn] = useState(0);
  const [nouveauPayOut, setNouveauPayOut] = useState(0);
  useEffect(() => {
    if (commission && show) {
      setNouveauPayIn(commission.payinCommissionPercentage || 0);
      setNouveauPayOut(commission.payoutCommissionPercentage || 0);
      setMontant(0);
    }
  }, [commission, show]);
 if (!commission) return null;
const { country, method: paymentMethod, payinCommissionPercentage, payoutCommissionPercentage } = commission ;
let commissionDetail = null;
const allCountries = Array.isArray(commissions)
  ? commissions
  : Object.values(commissions).flat();
const countryData = allCountries.find(
  (entry) => entry.country === country
);
if (countryData && Array.isArray(countryData.paymentMethods)) {
  commissionDetail = countryData.paymentMethods.find((m) => {
    const payMethod = m.paymentMethod?.toLowerCase?.() || "";
    const methodName = paymentMethod?.name?.toLowerCase?.() || "";
    const methodId = paymentMethod?.id?.toLowerCase?.() || "";
    return payMethod === methodName || payMethod === methodId;
  });
}
const actualPayIn = commissionDetail?.payinCommissionPercentage ?? payinCommissionPercentage;
const actualPayOut = commissionDetail?.payoutCommissionPercentage ?? payoutCommissionPercentage;
const calculPayIn = (montant * actualPayIn) / 100;
const calculPayOut = (montant * actualPayOut) / 100;
const calculNouPayIn = (montant * nouveauPayIn) / 100;
const calculNouPayOut = (montant * nouveauPayOut) / 100;
const fraisPayIn = calculPayIn / 2;
const fraisPayOut = calculPayOut / 2;
const fraisNouPayIn = calculNouPayIn / 2;
const fraisNouPayOut = calculNouPayOut / 2;
  const handleApply = () => {
    const newData = {
      ...commission,
      payinCommissionPercentage: nouveauPayIn,
      payoutCommissionPercentage: nouveauPayOut,
    };
    if (onApply) {
      onApply(newData);
    }
    onClose(); 
  };
  const handleCancel = () => {
    setNouveauPayIn(commission.payinCommissionPercentage || 0);
    setNouveauPayOut(commission.payoutCommissionPercentage || 0);
    setMontant(0);
    onClose();
  };
  

  return (
    <Modal
  show={show}
  onHide={handleCancel}
  centered
  className="custom-modal"
  size="lg"
  dialogClassName="responsive-modal"
>
  <Modal.Body>
    <div className="titless mb-2">
      <span>Simuler changement</span>
      <div className="methoP">
        <ReactCountryFlag
          countryCode={country}
          svg
          style={{ width: "24px", height: "24px" }}
        />
        <span style={{ marginLeft: "10px", wordBreak: "break-word" }}>
          {country} - {paymentMethod.name || paymentMethod.id}
        </span>
      </div>
      <div className="para">
        Simulez l'impact des changements de commission avant de les appliquer
      </div>
    </div>

    <div style={{ padding: "10px 10px" }}>
      <Form layout="vertical">
        <Form.Group className="mb-3">
          <Form.Label className="labelss">Montant de la transaction</Form.Label>
          <Form.Control
            type="number"
            value={montant}
            onChange={(e) => setMontant(parseFloat(e.target.value) || 0)}
          />
        </Form.Group>

        <Row className="g-2"> {/* gap entre colonnes */}
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="labelss">Nouveau taux Pay IN</Form.Label>
              <Form.Control
                type="number"
                value={nouveauPayIn}
                onChange={(e) => setNouveauPayIn(parseFloat(e.target.value) || 0)}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="labelss">Nouveau taux Pay Out</Form.Label>
              <Form.Control
                type="number"
                value={nouveauPayOut}
                onChange={(e) => setNouveauPayOut(parseFloat(e.target.value) || 0)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>

    <Row className="g-2">
      <Col xs={12} md={6}>
        <Card style={{ borderColor: '#E1E1E1', padding: '10px', borderRadius: '4px' }}>
          <button className="buttonAct mb-3" style={{ width: "100%", maxWidth: "86px", height: "35px" }}>
            Actuel
          </button>
          <Card className="mb-3">
            <div className="labelNoire">Pay In : {calculPayIn.toFixed(2)} XOF</div>
            <div className="labelGris">Taux: {actualPayIn || 0}%</div>
            <div className="labelNoire">Frais OP : {fraisPayIn} XOF</div>
            <div className="labelNoire">Pay IN Agr : {fraisPayIn} XOF</div>
          </Card>
          <Card>
            <div className="labelNoire">Pay Out : {calculPayOut.toFixed(2)} XOF</div>
            <div className="labelGris">Taux: {actualPayOut || 0}%</div>
            <div className="labelNoire">Frais OP : {fraisPayOut} XOF</div>
            <div className="labelNoire">Pay Out Agr : {fraisPayOut} XOF</div>
          </Card>
        </Card>
      </Col>

      <Col xs={12} md={6}>
        <Card style={{ borderColor: '#396AFC', padding: '10px', borderRadius: '4px' }}>
          <Button className="buttonNou mb-3" style={{ width: "100%", maxWidth: "89px", height: "35px" }}>
            Nouveau
          </Button>
          <Card className="mb-3">
            <div className="labelBleu">Pay In : {calculNouPayIn.toFixed(2)} XOF</div>
            <div className="labelGris">Taux: {nouveauPayIn || 0}%</div>
            <div className="labelBleu">Frais OP : {fraisNouPayIn} XOF</div>
            <div className="labelBleu">Pay IN Agr : {fraisNouPayIn} XOF</div>
          </Card>
          <Card>
            <div className="labelBleu">Pay Out : {calculNouPayOut.toFixed(2)} XOF</div>
            <div className="labelGris">Taux: {nouveauPayOut || 0}%</div>
            <div className="labelBleu">Frais OP : {fraisNouPayOut} XOF</div>
            <div className="labelBleu">Pay Out Agr : {fraisNouPayOut} XOF</div>
          </Card>
        </Card>
      </Col>
    </Row>

    <div style={{ padding: '0 10px', marginTop: "20px" }}>
      <Button
        className="buttonSui"
        style={{ width: "100%", height: "38px", marginBottom: "10px" }}
        onClick={handleApply}
      >
        Appliquer le taux
      </Button>

      <button
        className="buttonAnn"
        style={{ width: "100%", height: "38px", marginTop: "10px" }}
        onClick={handleCancel}
      >
        Annuler
      </button>
    </div>
  </Modal.Body>
</Modal>

  );
};
export default SimulerChangementCountryModal;
